export const shopRoles = {
  SHOP_ADMIN: 'SHOP_ADMIN',
  SHOP_USER: 'SHOP_USER',
  SHOP_SCOPE_EXPLORER: 'SHOP_SCOPE_EXPLORER',
  ISSUER_DASHBOARD: 'ISSUER_DASHBOARD',
};

export const allShopRoles = Object.values(shopRoles);
